import React, { Component } from 'react';
import { NumberInput } from '../components/NumberInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { TermSelect } from '../components/TermSelect.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    updateLead(props:any):void;
    coverTerm?: number;
    coverAmount?: number;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    coverTerm?: number;
    coverAmount?: number;
}

export class CoverAmount extends Component<IProps, IState> {

    constructor (props: IProps) {
        super(props);
        this.state = {hasError: false, coverTerm: this.props.coverTerm ?? 25, coverAmount: this.props.coverAmount};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
        if (!this.props.coverTerm)
            this.props.updateLead({coverTerm:25});
    }

    nextStep() {
        if (!this.state.coverTerm || !this.state.coverAmount) {
            var errors:string[]=[];
            if (!this.state.coverTerm) {
                errors.push("Term is required");
            }
            if (!this.state.coverAmount) {
                errors.push("Cover amount is required");
            }
            this.setState({errors: errors, hasError: true});
            return;
        }
        this.props.nextStep();
    }

    render() {

        return (
            <header className="App-header">
                <div className='wrapper'>
                    <h1 className='l'>How much <span className='doddltext'>cover</span> do you need?</h1>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <NumberInput
                                id='monthlyrepayments'
                                key='monthlyrepayments'
                                label={<>With a cover amount of</>}
                                value={this.props.coverAmount}
                                classes={this.state.hasError && !this.state.coverAmount ? "e" : ""}
                                onChange={(e) => { this.setState({coverAmount: e.target.value}); this.props.updateLead({coverAmount:e.target.value}); }} />
                        </div>
                        <div className='column2 justify-s'>
                            <TermSelect 
                                label={<>and a term of</>}
                                selectedterm={this.props.coverTerm}
                                classes={this.state.hasError && !this.state.coverTerm ? "e" : ""}
                                onChange={(e) => { this.setState({coverTerm: +e.target.value}); this.props.updateLead({coverTerm:+e.target.value}); }} />
                        </div>
                    </div>
                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>

                </div>
            </header>
        );
    }
}
